import { useNavigate } from 'react-router-dom'
import type { DashboardAlert } from '../../store/dashboardSlice'

interface DrugAlertsProps {
  alerts: DashboardAlert[]
}

const severityStyles: Record<string, string> = {
  Warning: 'bg-[#f5ecd8] text-status-warning',
  Critical: 'bg-[#f0d8d8] text-status-error',
}

export function DrugAlerts({ alerts }: DrugAlertsProps) {
  const navigate = useNavigate()

  return (
    <div data-testid="drug-alerts">
      <h2 className="text-[14px] font-medium text-text-primary mb-3">Drug Alerts</h2>

      {alerts.length === 0 ? (
        <p className="text-[12px] text-text-muted py-4 text-center" data-testid="drug-alerts-empty">
          No active drug alerts
        </p>
      ) : (
        <div className="flex flex-col">
          {/* Header */}
          <div
            className="dash-da-header grid items-center h-9 text-[11px] font-medium text-text-muted uppercase tracking-wide"
            style={{ gridTemplateColumns: '1fr 1fr 90px' }}
          >
            <span className="px-2">Patient</span>
            <span className="px-2">Conflicting Drugs / Allergens</span>
            <span className="px-2">Severity</span>
          </div>

          {/* Rows */}
          {alerts.map((alert) => (
            <div
              key={alert.id}
              data-testid={`drug-alert-row-${alert.id}`}
              onClick={() => navigate(`/prescriptions/${alert.prescription_id}`)}
              className="dash-da-row grid items-center h-[44px] text-[13px] text-text-primary hover:bg-hover transition-colors duration-100 cursor-pointer"
              style={{ gridTemplateColumns: '1fr 1fr 90px' }}
            >
              <span className="px-2 font-[500] truncate" data-testid="alert-patient-name">
                {alert.patient_name}
              </span>
              <span className="px-2 text-[12px] text-text-secondary truncate" data-testid="alert-drugs">
                {alert.conflicting_drugs || alert.description}
              </span>
              <span className="px-2" data-testid="alert-severity">
                <span
                  className={`inline-flex items-center h-5 px-1.5 rounded-[3px] text-[11px] font-medium ${severityStyles[alert.severity] || 'bg-[#e8e6e2] text-text-muted'}`}
                >
                  {alert.severity}
                </span>
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
